import type { ApplicationEdition } from '@jira/platform__application-editions/src/edition.tsx';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';

export const NCS = 'ncs';

export const PARENT_PRODUCT = 'JSM';
export const USER_ID_TYPE = 'atlassianAccount';
export const TEAM_NAME = 'jsm-nebula';

export const MONTHLY_BILLED = 'MONTHLY' as const;
export const ANNUALLY_BILLED = 'ANNUAL' as const;
export const INACTIVE = 'INACTIVE' as const;

export type BillingPeriod = typeof MONTHLY_BILLED | typeof ANNUALLY_BILLED | typeof INACTIVE;
export const NATIVE_CONFLUENCE = 'NATIVE_CONFLUENCE';
export const SERVER_CONFLUENCE = 'SERVER_CONFLUENCE';
export const CROSS_SITE_CONFLUENCE = 'CROSS_SITE_CONFLUENCE';
export const SHAREPOINT = 'SHAREPOINT';
export const GOOGLE_DRIVE = 'GOOGLE_DRIVE';
export const GOOGLE_DRIVE_CONNECTOR = 'google-drive-connector';
export const SHAREPOINT_CONNECTOR = 'sharepoint-connector';
export const INTERNAL_VISIBILITY = 'INTERNAL';
export const EXTERNAL_VISIBILITY = 'EXTERNAL';
export type Visibility = typeof INTERNAL_VISIBILITY | typeof EXTERNAL_VISIBILITY;
export type SourceType = typeof SHAREPOINT | typeof GOOGLE_DRIVE;

export type ProductDetails = {
	edition: ApplicationEdition;
	billingPeriod: BillingPeriod;
	trialEndDate: Date | null;
	firstSiteActivationDate: number;
};

export const GoogleDriveAri: string = createAri({
	resourceOwner: 'platform',
	resourceType: 'integration',
	resourceId: 'google',
});

export const SharePointAri: string = createAri({
	resourceOwner: 'platform',
	resourceType: 'integration',
	resourceId: 'microsoft',
});
